
<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{'Accounting Master Files' | translate }}</h1>
          <p>{{'Enter Accounting Master Files' | translate }}</p>
      </div>
</div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
  <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                      <li></li>
                      <li></li>
                  </ul>
              </div>

          </div>
  </div>
</section>
<div class="w3l-form-25">
  <BR>
      <label style="width: 250px;">   </label>
      <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
      <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
    </div>
<div id="w3l-appointment">
  <section class="appointment-section section-gap">
    <div class="wrapper">
            <div class="appointment-form">
                <form action="#" method="post">
                    <div class="fields-grid">

                      <a href="Stores" class="drop-text">
                        <button type="button" class="theme-button btn" name="stores" style="height: 100px;width:20%;" ><i class="fa fa-building-o" style='font-size:48px;color:rgb(21, 103, 179)'></i> {{'Stores settings' | translate }}</button>
                      </a>
                        <label  style="width:2%;"></label>
                        <a href="RevenueTypes" class="drop-text">
                        <button type="button" class="theme-button btn" name="revenue" style="height: 100px;width:20%;"><i class="fa fa-bars" style='font-size:48px;color:rgb(21, 103, 179)'></i> {{'Revenue settings' | translate }}</button>
                         </a>
                        <label style="width:2%;"></label>
                        <a href="ExpensesType" class="drop-text">
                        <button type="button" class="theme-button btn" name="expenses" style="height: 100px;width:20%;"><i class="fa fa-money" style='font-size:48px;color:rgb(21, 103, 179)'></i> {{'Expenses Settings' | translate }}</button>
                        </a>
                        <label style="width:2%;"></label>
                        <a href="Customers" class="drop-text">
                        <button type="button" class="theme-button btn" name="expenses" style="height: 100px;width:20%;"><i class="fa fa-money" style='font-size:48px;color:rgb(21, 103, 179)'></i> {{'customers Settings' | translate }}</button>
                        </a>
                        <label style="width:2%;"></label>
                        <a href="BanksSettings" class="drop-text">
                        <button type="button" class="theme-button btn" name="bank" style="height: 100px;width:20%;"><i class="fa fa-university" style='font-size:48px;color:rgb(21, 103, 179)'></i> {{'Banks Settings' | translate }}</button>
                      </a>

                    </div>
                    <div class="fields-grid">
                      <a href="Home">
                        <button type="button" class="theme-button btn" style="width: 100%;height: 100px;" name="Back"><i class="fa fa-home" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Home' | translate }}</button>
                       </a>
                    </div>
                </form>
            </div>


        <div class="clear"> </div>
    </div>
</section>
</div>
